import { useEffect, useState } from "react";
import {useParams } from "react-router-dom"

function Detail() {
    const {id} = useParams(); //id를 알고있으니까
    const [loading, setLoading] = useState(true);
    const [movie, setMovie] = useState();
    const getMovie = async() => { //API로부터 정보를fetch해올 수 있다
        const json = await ( 
            await fetch(`https://yts.mx/api/v2/movie_details.json?movie_id=${id}`)
        ).json();
        console.log(json.data.movie);
        setMovie(json.data.movie);
        setLoading(false);
    };
    useEffect(() => {
        getMovie();
    }, []);
    return (
        <div>
            {loading ? <h1>Loading...</h1> : (
                <div>
                    <h1>{movie.title_long}</h1>
                    <div>
                        <img src={movie.medium_cover_image} alt={movie.title}></img>
                    </div>
                    <h3>rating : {movie.rating}</h3>
                    <h3>runtime : {movie.runtime}</h3>
                    <ul><h4>
                        {movie.genres.map((genre) => (
                        <li key={genre}>{genre}</li>
                       ))}
                    </h4></ul>
                </div>
            )}
        </div>
    );
}

export default Detail;